<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl m-4">
        <div class="flex justify-between p-5 px-8 bg-primary rounded-t-2xl ">
            <div class="text-3xl text-white self-center"><b>
                    {{ wpbRecord?.stringShortName }}
                </b></div>
            <div class="self-center" style="color: #dbd3d3;font-size: medium">
                Amend Work Planning Budget Details
            </div>
        </div>

        <div class="p-12">
            <form [formGroup]="wpbForm">
                <div class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-2">
                        <mat-label>Field Name</mat-label>
                        <input matInput formControlName="fieldLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Platform Name</mat-label>
                        <input matInput formControlName="platformLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Well Name</mat-label>
                        <input matInput formControlName="wellLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Well String Name</mat-label>
                        <input matInput formControlName="stringShortName" />
                    </mat-form-field>
                </div>

                <div class="divider my-6"></div>

                <div class="grid grid-cols-4 gap-x-8 mt-4">


                    <mat-form-field class="col-span-2">
                        <mat-label>Integrity Issue</mat-label>
                        <input matInput formControlName="integrityIssue" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Submission Date</mat-label>
                        <input matInput [matDatepicker]="submissionDate" formControlName="submissionDate" />
                        <mat-datepicker-toggle matIconSuffix [for]="submissionDate"></mat-datepicker-toggle>
                        <mat-datepicker #submissionDate></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Submission Year</mat-label>
                        <input matInput formControlName="submissionYear" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Submission Type</mat-label>
                        <input matInput formControlName="submissionType" />
                    </mat-form-field>
                </div>

                <div class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-2">
                        <mat-label>Plan Execution Date</mat-label>
                        <input matInput [matDatepicker]="planExecutionDate" formControlName="planExecutionDate" />
                        <mat-datepicker-toggle matIconSuffix [for]="planExecutionDate"></mat-datepicker-toggle>
                        <mat-datepicker #planExecutionDate></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Plan Cost (RM)</mat-label>
                        <span matTextSuffix>MIl</span>
                        <input matInput type="number" formControlName="planCostRmMil" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="wpbStatus">
                            <mat-select-trigger class="rounded">
                                <span class="p-2 font-semibold" [ngClass]="{
                                    'bg-yellow': wpbForm.get('wpbStatus')?.value === 'Open',
                                    'bg-green': wpbForm.get('wpbStatus')?.value === 'Closed'
                                }">
                                    {{ wpbForm.get('wpbStatus')?.value || 'Select Status' }}
                                </span>
                            </mat-select-trigger>

                            <mat-option [value]="'Open'">
                                <div class="bg-yellow p-2 rounded text-center text-black w-20">Open</div>
                            </mat-option>
                            <mat-option [value]="'Closed'">
                                <div class="bg-green p-2 rounded text-center text-black w-20">Closed</div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Actual Cost (RM)</mat-label>
                        <span matTextSuffix>MIl</span>
                        <input matInput type="number" formControlName="actualCostRmMil" />
                        <mat-error *ngIf="wpbForm.controls.actualCostRmMil.hasError('required')">
                            Actual Cost is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-4 mt-2">
                        <mat-label>Proposal Description</mat-label>
                        <textarea matInput formControlName="proposalDesc" rows="5"></textarea>
                    </mat-form-field>

                    <mat-form-field class="col-span-4">
                        <mat-label>Remark</mat-label>
                        <textarea matInput formControlName="remark" rows="5"></textarea>
                    </mat-form-field>
                </div>

                <div class="divider my-6"></div>

                <ng-container *ngIf="updateBy && updateDate; else showInputBy">
                    <div class="grid grid-cols-4 gap-x-8 mt-4">
                        <mat-form-field class="col-span-2">
                            <mat-label>Updated By</mat-label>
                            <input matInput formControlName="updateBy" />
                        </mat-form-field>

                        <mat-form-field class="col-span-2">
                            <mat-label>Updated Date</mat-label>
                            <input matInput formControlName="updateDate" />
                        </mat-form-field>
                    </div>
                </ng-container>

                <ng-template #showInputBy>
                    <div class="grid grid-cols-4 gap-x-8 mt-4">
                        <mat-form-field class="col-span-2">
                            <mat-label>Created By</mat-label>
                            <input matInput formControlName="inputBy" />
                        </mat-form-field>

                        <mat-form-field class="col-span-2">
                            <mat-label>Created Date</mat-label>
                            <input matInput formControlName="inputDate" />
                        </mat-form-field>
                    </div>
                </ng-template>
            </form>
        </div>
    </div>
</div>


<div class="fixed bottom-0 right-0 p-4 bg-card w-full">
    <div class="flex justify-end">
        <button class="btn btn-primary mx-2" (click)="location.back()">
            Back
        </button>
        <button class="btn btn-outline btn-default" [disabled]="!hasFormChanged() || !wpbForm.valid "
            (click)="editWpb()">
            Update
        </button>
    </div>
</div>